import AboutEstimator from './AboutEstimator'
import Awards from './Awards'
import Banner from './Banner'
import Button from './Button'
import Cards from './Cards'
import Custom from './Custom'
import Divider from './Divider'
import Documents from './Documents'
import Gallery from './Gallery'
import Image from './Image'
import Logo from './Logo'
import Mission from './Mission'
import Pictures from './Pictures'
import Quote from './Quote'
import Services from './Services'
import SliderImage from './SliderImage'
import SocialLinks from './SocialLinks'
import Spacer from './Spacer'
import Terms from './Terms'
import Testimonials from './Testimonials'
import Text from './Text'
import ThreeColumn from './ThreeColumn'
import TwoColumn from './TwoColumn'
import WorkOrder from './WorkOrder'
import partnerBlocks from './partners'

export default {
  // Sherwin-Williams partner content, reused from v1 (#21311)
  ...partnerBlocks,
  '2-column': TwoColumn,
  '3-column': ThreeColumn,
  'about-estimator': AboutEstimator,
  awards: Awards,
  banner: Banner,
  logo: Logo,
  button: Button,
  cards: Cards,
  custom: Custom,
  divider: Divider,
  documents: Documents,
  image: Image,
  gallery: Gallery,
  mission: Mission,
  pictures: Pictures,
  quote: Quote,
  services: Services,
  'slider-image': SliderImage,
  'social-links': SocialLinks,
  terms: Terms,
  testimonials: Testimonials,
  text: Text,
  spacer: Spacer,
  'work-order': WorkOrder
}

import AboutEstimatorBlock from './AboutEstimator/AboutEstimatorBlock'
import AwardsBlock from './Awards/AwardsBlock'
import BannerBlock from './Banner/BannerBlock'
import ButtonBlock from './Button/ButtonBlock'
import CardsBlock from './Cards/CardsBlock'
import CustomBlock from './Custom/CustomBlock'
import DividerBlock from './Divider/DividerBlock'
import DocumentsBlock from './Documents/DocumentsBlock'
import GalleryBlock from './Gallery/GalleryBlock'
import ImageBlock from './Image/ImageBlock'
import LogoBlock from './Logo/LogoBlock'
import MissionBlock from './Mission/MissionBlock'
import PicturesBlock from './Pictures/PicturesBlock'
import QuoteBlock from './Quote/QuoteBlock'
import ServicesBlock from './Services/ServicesBlock'
import SliderImageBlock from './SliderImage/SliderImageBlock'
import SocialLinksBlock from './SocialLinks/SocialLinksBlock'
import SpacerBlock from './Spacer/SpacerBlock'
import TermsBlock from './Terms/TermsBlock'
import TestimonialsBlock from './Testimonials/TestimonialsBlock'
import TextBlock from './Text/TextBlock'
import ThreeColumnBlock from './ThreeColumn/ThreeColumnBlock'
import TwoColumnBlock from './TwoColumn/TwoColumnBlock'
import WorkOrderBlock from './WorkOrder/WorkOrderBlock'

export {
  AboutEstimatorBlock,
  AwardsBlock,
  BannerBlock,
  ButtonBlock,
  CardsBlock,
  CustomBlock,
  DividerBlock,
  DocumentsBlock,
  GalleryBlock,
  ImageBlock,
  LogoBlock,
  MissionBlock,
  PicturesBlock,
  QuoteBlock,
  ServicesBlock,
  SliderImageBlock,
  SocialLinksBlock,
  SpacerBlock,
  TermsBlock,
  TestimonialsBlock,
  TextBlock,
  ThreeColumnBlock,
  TwoColumnBlock,
  WorkOrderBlock
}
